import React from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { analyticsIds } from '../../../../../constants/analyticsIds';
import { getRowValue } from '../../../../../utils/tableUtil';

const ParentIdCell = ({ row, value: parentInsured }) => {
  const { url } = useRouteMatch();
  const job = getRowValue(row, 'job');
  const id = parentInsured?.externalId || parentInsured?.id;

  return (
    <Box maxW="200px">
      <Link
        data-analytics-id={analyticsIds.reportsPage.insuredParentIdLink}
        rel="noopener noreferrer"
        target="_blank"
        title={parentInsured?.externalId || parentInsured?.id}
        to={url.replace(/reports.*/, `insureds/${parentInsured?.id}`)}
      >
        {id}
      </Link>
    </Box>
  );
};

ParentIdCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      job: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
      department: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
    })
  }),
  value: PropTypes.shape({ parentInsured: PropTypes.oneOfType([PropTypes.object, PropTypes.array]) })
};

export default ParentIdCell;
